export default __webpack_public_path__ + "static/features-panel2-bf831fcafd96b8fb6ff8e30e46eab955.png";